import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Users2 } from "lucide-react";
import api from "../../lib/api";
import GroupVersionEditor, { LANGS } from "./GroupVersionEditor";
import GroupAudiencePicker from "./GroupAudiencePicker";
import GroupSendPanel from "./GroupSendPanel";
import GroupEmailHistory from "./GroupEmailHistory";
import { useEmailSettings } from "./useEmailSettings";

const EMPTY = Object.fromEntries(LANGS.map((l) => [l, { subject: "", body: "" }]));

export default function GroupEmailComposer() {
  const { t } = useTranslation();
  const { test_email: testEmail } = useEmailSettings();
  const [versions, setVersions] = useState(EMPTY);
  const [lang, setLang] = useState("en");
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [loadError, setLoadError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    api.get("/admin/group-email/audience").then((r) => setUsers(r.data || []))
      .catch((e) => setLoadError(e.response?.data?.detail || t("admin.emailNetworkError")));
  }, [t]);
  const update = useCallback((l, patch) => setVersions((v) => ({ ...v, [l]: { ...v[l], ...patch } })), []);

  return (
    <section className="space-y-4" data-testid="group-email">
      <div>
        <h2 className="text-base md:text-lg font-display text-slate-100 flex items-center gap-2">
          <Users2 size={16} className="text-amber-400" />{t("groupEmail.title")}
        </h2>
        <p className="text-sm text-slate-400 max-w-3xl mt-1">{t("groupEmail.subtitle")}</p>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <GroupVersionEditor versions={versions} lang={lang} onLang={setLang} onChange={update} t={t} />
        <GroupAudiencePicker users={users} loadError={loadError} selected={selected} onChange={setSelected} t={t} />
      </div>
      <GroupSendPanel versions={versions} lang={lang} users={users} selected={selected} testEmail={testEmail}
        onRunDone={() => { setReloadKey((k) => k + 1); setSelected(new Set()); }} t={t} />
      <GroupEmailHistory reloadKey={reloadKey} t={t} />
    </section>
  );
}
